<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { 
        fetchProductos, 
        saveProducto, 
        removeProducto, 
        searchProductos, 
        subscribeToProductos, 
        unsubscribeFromProductos,
        fetchAtributosProducto,
        saveAtributosProducto,
        uploadGalleryImages,
        fetchCategoriasProducto,
        saveCategoriasProducto,
        fetchCategoriasDisponibles
    } from '../controllers/productoController.js';

    // Configuración de las columnas para la tabla de productos
    let productoColumns = [
        { label: 'Nombre', field: 'nombre', type: 'text' },
        { label: $t('fields.description'), field: 'descrip', type: 'text' },
        { label: 'Precio', field: 'precio', type: 'currency' },
        { label: $t('categories.categories'), field: 'categorias', type: 'categories' },
        { label: 'Productos Padre', field: 'parent', type: 'categories' },
        { label: $t('fields.image'), field: 'firstImage', type: 'gallery_image' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' }
    ];

    // Estructura del nuevo objeto Producto
    let newProducto = {
        nombre: '',
        descrip: '',
        parent: [], // Relación con productos padre para jerarquías (multiselect)
        precio: 0,
        sta: true,
        atributos: [], // Atributos adicionales
        categorias: [], // Categorías del producto
    };

    // Configuración de los campos para la edición de productos
    let editColumns = [
        { label: 'Nombre', key: 'nombre', type: 'text', required: true },
        { label: $t('fields.description'), key: 'descrip', type: 'text', required: true },
        { label: 'Precio', key: 'precio', type: 'number', required: true, min: 0, step: 0.01 },
        { label: $t('categories.categories'), key: 'categorias', type: 'multiselect', required: false, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'Productos Padre', key: 'parent', type: 'multiselect', required: false, fetchOptions: { key: 'id', value: 'nombre' }, options: [] },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox' }
    ];

    // Función para cargar y transformar productos padre
    let parentOptions = [];
    let categoriaOptions = [];

    async function loadParentProducts() {
        try {
            const fetchedProductos = await fetchProductos(1, 1000);

            if (Array.isArray(fetchedProductos.producto)) {
                parentOptions = fetchedProductos.producto.map(e => ({
                    key: e[editColumns.find(col => col.key === 'parent').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'parent').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'parent').options = parentOptions;
            } else {
                console.error('Se esperaba un array de productos, pero se obtuvo:', fetchedProductos);
            }
        } catch (error) {
            console.error('Error al cargar los productos padre:', error);
        }
    }

    async function loadCategorias() {
        try {
            const fetchedCategorias = await fetchCategoriasDisponibles();

            if (Array.isArray(fetchedCategorias)) {
                categoriaOptions = fetchedCategorias.map(e => ({
                    key: e[editColumns.find(col => col.key === 'categorias').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'categorias').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'categorias').options = categoriaOptions;
            } else {
                console.error('Se esperaba un array de categorías, pero se obtuvo:', fetchedCategorias);
            }
        } catch (error) {
            console.error('Error al cargar las categorías:', error);
        }
    }

    // Cargar los productos padre y categorías al montar el componente
    onMount(() => {
        loadParentProducts();
        loadCategorias();
    });
</script>

<CRUD 
    title={$t('entities.productos')}
    entityName="producto"
    newEntity={newProducto}
    columns={productoColumns}
    fetchEntities={fetchProductos}
    saveEntity={saveProducto}
    removeEntity={removeProducto}
    searchEntities={searchProductos}
    subscribeToChanges={subscribeToProductos}
    unsubscribeFromChanges={unsubscribeFromProductos}
    editColumns={editColumns}
    fetchAtributos={fetchAtributosProducto}
    fetchCategorias={fetchCategoriasProducto}
    uploadGalleryImages={uploadGalleryImages}
    enableGallery={true}
    enableCategories={true}
    galleryConfig={{ collection: 'producto_gallery', relationField: 'producto', urlField: 'url', fileField: 'url', tabLabel: $t('gallery.gallery') }}
    categoryConfig={{ collection: 'categoria_producto', relationField: 'producto', categoryField: 'categoria', tabLabel: $t('categories.categories') }}
/>
